import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, Button, Form, Label, Input, Col, Row, Alert} from 'reactstrap';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../../reducers/common/localization";

class CreateAccreditationGroupModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            accreditationGroupName: ''
        }
    }

    render() {
        return (
            <Modal className="accreditation-group-modal" isOpen={this.props.isOpen} toggle={this.props.onCancel}>
                <ModalBody>
                    {this.props.isOrgValidated ? null :
                        <Alert color="warning">{_.get(this.props.translation, 'main.non_validated_org_access_label')}</Alert>}
                    {this.renderModalBody()}
                </ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <Form onSubmit={this.handleSubmit}>
                <Row className="modal-form-field-container">
                    <Col sm={3} className="modal-label-container">
                        <Label>{_.get(this.props.translation, 'org_staff.accreditation_groups.accreditation_group_name_label') + '*'}</Label>
                    </Col>
                    <Col sm={8}>
                        <Input type="text"
                               placeholder={`${_.get(this.props.translation, 'org_staff.accreditation_groups.accreditation_group_name_label')}`}
                               required
                               onChange={this.handleChange('accreditationGroupName')}/>
                    </Col>
                </Row>
                <div className="modal-buttons-container">
                    <Button color="secondary"
                            onClick={this.props.onCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                    <Button className="olive-green-btn" type="submit" disabled={!this.props.isOrgValidated}>
                        {_.get(this.props.translation, 'org_staff.accreditation_groups.create_accreditation_group_button')}
                    </Button>
                </div>
            </Form>
        );
    }

    handleChange = (inputName) => (e) => {
        this.setState({[inputName]: e.target.value});
    };

    handleSubmit = (e) => {
        e.preventDefault();
        let data = {
            name: this.state.accreditationGroupName
        };

        this.props.onAccreditationGroupCreate(data);
    }
}

CreateAccreditationGroupModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    isOrgValidated: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onAccreditationGroupCreate: PropTypes.func,
    onCancel: PropTypes.func
};

export default CreateAccreditationGroupModal;



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/AccreditationGroupModal/CreateAccreditationGroupModal/CreateAccreditationGroupModal.js